<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="card-icon">
        <md-icon>view_module</md-icon>
      </div>
      <md-toolbar class="fm-card-header">
        <h4 class="md-title">Advanced Setup</h4>
        <md-button
          data-tour="application_advanced_expand_button"
          class="md-simple"
          @click="showAdvancedConfigs = !showAdvancedConfigs"
        >
          <md-icon
            >keyboard_arrow_{{ showAdvancedConfigs ? "up" : "right" }}</md-icon
          >
          {{ showAdvancedConfigs ? "Collapse" : "Expand" }}
        </md-button>
      </md-toolbar>
    </md-card-header>
    <md-card-content v-if="showAdvancedConfigs">
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <div class="card-wrapper" data-tour="advanced_sfu">
            <edit-sfu-config-form
              v-bind:channel="defaultChannel"
              v-bind:ogChannel="defaultOgChannel"
              :simulcastAuthorized="features.simulcast"
              header-color="primary"
              @validationErrorChanged="onValidationErrorChanged"
            ></edit-sfu-config-form>
          </div>
          <div class="card-wrapper" data-tour="advanced_audio">
            <edit-audio-codecs-form
              v-bind:channel="defaultChannel"
              v-bind:ogChannel="defaultOgChannel"
              header-color="primary"
              @validationErrorChanged="onValidationErrorChanged"
            ></edit-audio-codecs-form>
          </div>
          <div class="card-wrapper" data-tour="advanced_video">
            <edit-video-codecs-form
              v-bind:channel="defaultChannel"
              v-bind:ogChannel="defaultOgChannel"
              header-color="primary"
              @validationErrorChanged="onValidationErrorChanged"
            ></edit-video-codecs-form>
          </div>
          <div class="card-wrapper" data-tour="advanced_rtmp">
            <edit-rtmp-config-form
              v-bind:channel="defaultChannel"
              v-bind:ogChannel="defaultOgChannel"
              v-bind:loadingFeature="loadingFeatures"
              :header-color="features.rtmp ? 'primary':''"
              :rtmpEnabled="features.rtmp"
              @validationErrorChanged="onValidationErrorChanged"
            ></edit-rtmp-config-form>
          </div>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <div class="card-wrapper" data-tour="advanced_mcu">
            <edit-mcu-config-form
              v-bind:channel="defaultChannel"
              v-bind:ogChannel="defaultOgChannel"
              header-color="primary"
              @validationErrorChanged="onValidationErrorChanged"
            ></edit-mcu-config-form>
          </div>
          <div class="card-wrapper" data-tour="advanced_recording">
            <edit-recording-config-form
              v-bind:channel="defaultChannel"
              v-bind:ogChannel="defaultOgChannel"
              v-bind:recordingAuthorized="features.recording"
              v-bind:loadingFeature="loadingFeatures"
              :header-color="features.recording ? 'primary' : ''"
            ></edit-recording-config-form>
          </div>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import {
  EditMcuConfigForm,
  EditAudioCodecsForm,
  EditVideoCodecsForm,
  EditRtmpConfigForm,
  EditRecordingConfigForm,
  EditSfuConfigForm
} from "@/pages";

import { ValidationErrors } from "@/utils/validationErrors";

export default {
  props: {
    appId: null,
    defaultChannel: null,
    defaultOgChannel: null
  },
  components: {
    EditMcuConfigForm,
    EditAudioCodecsForm,
    EditVideoCodecsForm,
    EditRecordingConfigForm,
    EditRtmpConfigForm,
    EditSfuConfigForm
  },
  data: () => ({
    showAdvancedConfigs: false,
    validationErrors: new ValidationErrors(),
    features: {
      recording: false,
      rtmp: false,
      simulcast: false
    },
    loadingFeatures: true,
  }),
  created() {
    this.$store
      .dispatch("subscription/loadSubscription", localStorage.subscriptionId)
      .then((result) => {
        Object.entries(this.features).forEach(([feature,_]) => {
          this.features[feature] = result.enabledFeatures.includes(feature);
        });
        this.loadingFeatures = false;
      });
  },
  computed: {
    validationError() {
      return this.validationErrors.hasError;
    }
  },
  methods: {
    onValidationErrorChanged(component, isError) {
      this.validationErrors.setError(component, isError);
    }
  },
  watch: {
    validationError(val) {
      this.$emit("validationErrorChanged", val);
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .contextual-help-mini i {
  margin-bottom: 6px;
}
/deep/ .contextual-help > a,
/deep/ .contextual-help-mini > a {
  margin-top: -3px;
}
</style>
